window.SMMFetch = async function (method, url, body, init, showErrors) {
  method = method.toUpperCase();
  if (!init) init = {};
  init.method = method;
  if (body) {
    init.headers = { ...init.headers, 'Content-Type': 'application/json' };
    init.body = JSON.stringify(body);
  }
  const UNEXPECTED_ERROR =
    'Something went wrong... Try again later or <a class="link" target="_blank" href="/pages/support?oseid=Fuz5otFbe8Q5kS9QDrQv84DK﻿">contact support</a>';
  const res = fetch(`/apps/smm${url}`, init).then(
    async res => {
      if (res.ok) {
        try {
          const data = await res.json();
          return data;
        } catch (error) {
          return undefined;
        }
      } else {
        try {
          var error = await res.json();
        } catch (error) {
          throw new Error(UNEXPECTED_ERROR);
        }
        throw new Error(error.message);
      }
    },
    () => {
      throw new Error(UNEXPECTED_ERROR);
    },
  );

  if (showErrors) {
    res.catch(error => {
      showPopupQuery({
        name: showErrors === true ? 'general' : showErrors,
        headerText: 'Error',
        bodyHtml: error.message,
        isNotification: true,
        confirmText: 'Done',
      });
    });
  }

  return res;
};

function makePopupHelper(selector) {
  const elems = selector.querySelectorAll('.popup-help');
  elems.forEach(element => {
    const span = document.createElement('span');
    span.classList.add('popup-help-container');
    span.innerHTML = element.title;
    element.append(span);
  });
}
window.makePopupHelper = makePopupHelper;

(function () {
  window.addEventListener('DOMContentLoaded', function () {
    const storageKey = 'acceptedCookies';
    const cookie = localStorage.getItem(storageKey);
    const hasAcceptedCookies = JSON.parse(cookie || 'false');

    function moveChatDown() {
      let timer;
      const move = () => {
        const chatBubble = document.querySelector('iframe#launcher')?.closest('div[style="visibility: visible;"]');
        if (chatBubble) {
          chatBubble.querySelectorAll('iframe:not([name="Messaging window"])').forEach(frame => (frame.style.marginBottom = '-80px'));
          // clearInterval(timer);
        }
      };
      timer = setInterval(move, 500);
      move();
    }

    if (hasAcceptedCookies) {
      moveChatDown();
      return;
    }

    const cookieBanner = document.getElementById('aa-cookie-banner');

    if (!cookieBanner) {
      moveChatDown();
      return;
    }

    setTimeout(() => {
      cookieBanner.classList.remove('fadeIn');
      cookieBanner.style.display = 'flex';
    }, 1000);

    cookieBanner.querySelector('.cab-button').addEventListener('click', function () {
      cookieBanner.classList.add('fadeOut');

      moveChatDown();

      setTimeout(() => {
        cookieBanner.style.display = 'none';
        cookieBanner.classList.remove('fadeOut');
      }, 200);

      localStorage.setItem(storageKey, 'true');
    });
  });
})();

(function () {
  try {
    window.addEventListener('DOMContentLoaded', function () {
      const urlParams = new URLSearchParams(window.location.search);
      const param = urlParams.get('focus');
      if (param != null) sessionStorage['focus'] = param == 'false' ? 'false' : 'true';

      if (sessionStorage['focus'] != 'true') {
        for (const el of document.querySelectorAll('.focus-hidden')) {
          el.classList.remove('focus-hidden');
        }
      }
    });
  } catch (error) {
    // TODO handle error
  }
})();

(function () {
  try {
    function getElHeight(el) {
      var elHeight = el.offsetHeight;
      const style = window.getComputedStyle(el);
      elHeight += parseInt(style.getPropertyValue('margin-top'));
      elHeight += parseInt(style.getPropertyValue('margin-bottom'));
      return elHeight;
    }
    class SmoothAccordion {
      constructor(el) {
        // Store the <details> element
        this.el = el;
        // Store the <summary> element
        this.summary = el.querySelector('summary');
        this.content = Array.from(el.querySelectorAll('summary ~ *'));

        // Store the animation object (so we can cancel it if needed)
        this.animation = null;
        // Detect user clicks on the summary element
        this.summary.addEventListener('click', this.onClick.bind(this));
        // this.el.addEventListener('toggle', this.onToggle.bind(this));
      }

      setClosing(value) {
        this.el.dataset.isClosing = value;
      }

      isClosing() {
        return this.el.dataset.isClosing === 'true';
      }

      setExpanding(value) {
        this.el.dataset.isExpanding = value;
      }

      isExpanding() {
        return this.el.dataset.isExpanding === 'true';
      }

      onClick(e) {
        // Stop default behaviour from the browser
        e.preventDefault();
        // Add an overflow on the <details> to avoid content overflowing
        this.el.style.overflow = 'hidden';
        // Check if the element is being closed or is already closed
        if (this.isClosing() || !this.el.open) {
          this.open();
          // Check if the element is being openned or is already open
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }

      shrink() {
        // Set the element as "being closed"
        this.setClosing(true);

        // Store the current height of the element
        const startHeight = `${this.el.offsetHeight}px`;
        // Calculate the height of the summary
        const endHeight = `${this.summary.offsetHeight}px`;

        // If there is already an animation running
        if (this.animation) {
          // Cancel the current animation
          this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.el.animate(
          {
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight],
          },
          {
            duration: 200,
            easing: 'ease-out',
          },
        );

        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(false);
        // If the animation is cancelled, isClosing variable is set to false
        this.animation.oncancel = () => this.setClosing(false);
      }

      open() {
        // Apply a fixed height on the element
        this.el.style.height = `${this.el.offsetHeight}px`;
        // Force the [open] attribute on the details element
        this.el.open = true;
        window.requestAnimationFrame(() => this.expand());
      }

      expand() {
        // Set the element as "being expanding"
        this.setExpanding(true);
        // Get the current fixed height of the element
        const startHeight = this.el.offsetHeight;
        // Calculate the open height of the element (summary height + content height)
        const endHeight = this.content.reduce((total, el) => total + getElHeight(el), getElHeight(this.summary));
        // If there is already an animation running
        if (this.animation) {
          // Cancel the current animation
          this.animation.cancel();
        }
        // Start a WAAPI animation
        this.animation = this.el.animate(
          {
            // Set the keyframes from the startHeight to endHeight
            height: [`${startHeight}px`, `${endHeight}px`],
          },
          {
            duration: 200,
            easing: 'ease-out',
          },
        );
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(true);
        // If the animation is cancelled, isExpanding variable is set to false
        this.animation.oncancel = () => this.setExpanding(false);
      }

      onAnimationFinish(open) {
        // Set the open attribute based on the parameter
        this.el.open = open;
        // Clear the stored animation
        this.animation = null;
        // Reset isClosing & isExpanding
        this.setClosing(false);
        this.setExpanding(false);
        // Remove the overflow hidden and the fixed height
        this.el.style.height = this.el.style.overflow = '';
      }
    }

    window.addEventListener('load', () => {
      document.querySelectorAll('details[smooth]').forEach(el => {
        new SmoothAccordion(el);
      });
    });
  } catch (error) {
    // TODO handle error
  }
})();

const trapFocusHandlers = {};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout, { passive: true });
  document.addEventListener('focusin', trapFocusHandlers.focusin, { passive: true });

  elementToFocus.focus();
}
window.trapFocus = trapFocus;

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener(
    'keydown',
    event => {
      if (navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    },
    { passive: true },
  );

  window.addEventListener(
    'mousedown',
    () => {
      mouseClick = true;
    },
    { passive: true },
  );

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    if (video.contentWindow?.postMessage)
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    if (video.contentWindow?.postMessage) video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
window.pauseAllMedia = pauseAllMedia;

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

(function () {
  try {
    document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

      if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
      }

      summary.addEventListener(
        'click',
        event => {
          event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        },
        { passive: true },
      );

      if (summary.closest('header-drawer')) return;
      summary.parentElement.addEventListener('keyup', onKeyUpEscape, { passive: true });
    });

    // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
    try {
      document.querySelector(':focus-visible');
    } catch (e) {
      focusVisiblePolyfill();
    }
  } catch (error) {
    // TODO handle error
  }
})();

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
window.QuantityInput = QuantityInput;
customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
window.debounce = debounce;

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
window.fetchConfig = fetchConfig;
/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function () {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class AAIcon extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('aa-icon', AAIcon);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', event => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
window.ModalDialog = ModalDialog;
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  videoIsPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);

  setActiveMedia(slideTemplate) {
    if (!slideTemplate.parentNode) return [];
    let sibling = slideTemplate.parentNode.firstChild;
    while (sibling) {
      if (sibling.nodeType === 1) {
        sibling.classList.remove('is-active');
      }
      sibling = sibling.nextSibling;
    }
    slideTemplate.classList.add('is-active');
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
    this.setActiveMedia(this.closest('li'));
    const mediaElement = this.querySelector('template + video');
    if (mediaElement && mediaElement.nodeName == 'VIDEO' && !this.videoIsPlaying(mediaElement)) {
      mediaElement.play().catch(() => {
        mediaElement.play();
      });
    }
  }
}
window.DeferredMedia = DeferredMedia;
customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  // NOTE: If initPages is called before images have a chance to load, scroll functionality will be prone to error.
  //  To mitigate this, apply a "min-width" style to the image elements in your slider so that the sliderItemOffset
  //  value is calculated accurately.
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.directSelector('.slider-counter--current');
    this.pageTotalElement = this.directSelector('.slider-counter--total');
    this.prevButton = this.directSelector('button[name="previous"]');
    this.nextButton = this.directSelector('button[name="next"]');

    if (!this.slider) return;

    this.resetPages();
    window.addEventListener('resize', debounce(this.initPages.bind(this), 50), { passive: true });

    this.slider.addEventListener('scroll', this.update.bind(this), { passive: true });
    this.prevButton?.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton?.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = this.sliderItems.filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length > 1) {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    }
    this.update();
  }

  resetPages() {
    this.sliderItems = Array.from(this.slider.querySelectorAll('[id^="Slide-"]')).filter(this.isDirect.bind(this));
    this.initPages();
  }

  directSelector(selector) {
    const el = this.querySelector(selector);
    if (this.isDirect(el)) return el;
    else return undefined;
  }
  isDirect(element) {
    return element?.closest('slider-component') == this;
  }

  preloadImages() {
    const range = 2;
    const idx = this.currentPage - 1;
    var i = Math.max(idx - range, 0);
    const end = Math.min(idx + range + 1, this.sliderItemsToShow.length - 1);
    for (; i < end; i++) {
      this.sliderItemsToShow[i].querySelectorAll('[loading="lazy"]').forEach(el => el.setAttribute('loading', 'eager'));
    }
  }

  update() {
    if (this.sliderItemsToShow.length > 1) {
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }

      if (this.currentPage != previousPage) {
        // this.preloadImages();
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        );
      }
    }
    if (this.enableSliderLooping) return;

    if (this.slider.scrollLeft <= 5) {
      this.prevButton?.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton?.removeAttribute('disabled');
    }

    if (this.slider.scrollLeft >= this.contentWidth() - this.slider.clientWidth - 256) {
      this.nextButton?.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton?.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  focusSlide(element, wiggle = 0, behavior = 'auto', recursive = false) {
    if (!this.sliderItems.includes(element)) return;
    const elementCenter = element.offsetLeft + element.clientWidth * 0.5;
    const sliderCenter = this.slider.scrollLeft + this.slider.clientWidth * 0.5;
    const start = sliderCenter - wiggle;
    const end = sliderCenter + wiggle; //this.slider.scrollLeft + this.slider.clientWidth - padding - element.clientWidth;

    if (elementCenter < start) {
      this.slideScrollPosition = this.slider.scrollLeft + (elementCenter - start);
    } else if (elementCenter > end) {
      this.slideScrollPosition = this.slider.scrollLeft + (elementCenter - end);
    }
    if (elementCenter < start || elementCenter > end) {
      this.slideScrollPosition = Math.max(0, Math.min(this.contentWidth() - this.slider.clientWidth, this.slideScrollPosition));
      this.slider.scrollTo({
        left: this.slideScrollPosition,
        behavior,
      });
    }

    if (recursive) {
      const slide = this.closest('[id^="Slide-"]');
      slide?.closest('slider-component')?.focusSlide(slide, wiggle, behavior);
    }
  }

  contentWidth() {
    if (!this.sliderItemsToShow || this.sliderItemsToShow.length == 0) return 0;
    const lastVisible = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    return lastVisible.offsetLeft + lastVisible.clientWidth;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}
window.SliderComponent = SliderComponent;
customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('[id^="Slide-"]');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }
  isDirect(element) {
    return element?.closest('slideshow-component') == this;
  }
  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}
window.SlideshowComponent = SlideshowComponent;
customElements.define('slideshow-component', SlideshowComponent);

class FocusHighlight extends HTMLElement {
  constructor() {
    super();
    this.target = undefined;
    window.addEventListener(
      'resize',
      function () {
        this.setTarget(this.target);
      }.bind(this),
    );
  }

  setTarget(target) {
    this.target = target;
    if (target) {
      target.offsetParent?.appendChild(this);
      this.style.display = 'block';
      this.style.width = `${target.clientWidth}px`;
      this.style.height = `${target.clientHeight}px`;
      this.style.left = `${target.offsetLeft}px`;
      this.style.top = `${target.offsetTop}px`;
    }
  }
}
window.FocusHighlight = FocusHighlight;
customElements.define('focus-highlight', FocusHighlight);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), select => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`,
    )
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

customElements.define(
  'smart-form',
  class extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.successHref = this.getAttribute('success-href');
      this.errorTarget = this.querySelector(this.getAttribute('error-target'));
      this.successTarget = document.getElementById(this.getAttribute('success-target'));
      this.formResetter = this.querySelector(this.getAttribute('form-resetter'));
      this.bindFormReset();
      this.form.onsubmit = this.smartSubmit.bind(this);
    }
    smartSubmit(event) {
      event.preventDefault();
      const form = this.form;
      const formData = new FormData(form);
      const data = {};
      for (const [key, value] of formData.entries()) {
        data[key] = value;
      }
      fetch(form.action, {
        method: form.method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        redirect: 'manual',
      }).then(res => {
        if (res?.ok) {
          res
            .json()
            .then(data => {
              if (data.url) window.location.href = data.url;
              if (this.successTarget) {
                //Pass data to next field
                for (const [key, value] of Object.entries(data)) {
                  const field = this.successTarget.querySelector(`input[name="${key}"]`);
                  if (field) field.value = value;
                }
              }
            })
            .finally(() => {
              if (this.successHref) window.location.href = this.successHref;
              window.scrollTo({ top: 0, behavior: 'smooth' });
            });
          this.hideError();
        } else {
          res.json().then(err => {
            if (this.errorTarget) {
              this.errorTarget.innerHTML = err.message;
              this.errorTarget.closest('.form__message').classList.remove('hidden');
            }
          });
        }
      });
      return false;
    }
    bindFormReset() {
      if (this.formResetter) {
        this.formResetter.addEventListener('click', () => {
          this.hideError();
          const fields = this.form.querySelectorAll('input');
          for (let i = 0; i < fields.length; i++) {
            fields[i].value = '';
          }
        });
      }
    }
    hideError() {
      if (this.errorTarget) {
        this.errorTarget.closest('.form__message').classList.add('hidden');
      }
    }
  },
);

/******************************
 **** Custom IIFE functions ***
 ******************************/

// Lightbox for displaying video
(function setupLightbox() {
  const lightboxes = Array.prototype.slice.call(document.querySelectorAll('div.lightbox-background'));

  if (!lightboxes.length) return;

  // Bind lightbox opener buttons
  const lightboxButtons = Array.prototype.slice.call(document.querySelectorAll('.show-lightbox-btn'));
  lightboxButtons.forEach(button => {
    const blockId = button.dataset.block_id;
    button.addEventListener('click', event => {
      event.preventDefault();
      document.getElementById(`lightbox-${blockId}`).classList.add('show');
    });
  });

  lightboxes.forEach(lightbox => {
    lightbox.querySelector('span.close-btn').addEventListener('click', () => {
      // Stop video and hide lightbox
      const blockId = lightbox.dataset.block_id;
      const videoIframe = document.getElementById(`lightbox-iframe-${blockId}`);
      videoIframe.contentWindow.postMessage('{"event": "command", "func": "pauseVideo", "args": ""}', '*');
      lightbox.classList.remove('show');
    });
  });
})();

window.addEventListener(
  'scroll',
  function () {
    const videosToReplay = document.querySelectorAll('.video-to-replay-on-scroll');
    videosToReplay.forEach(video => {
      const videoPosition = video.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (videoPosition < windowHeight) {
        video.play();
      } else {
        video.pause();
      }
    });
  },
  { passive: true },
);

(function () {
  if (window.location.pathname === '/pages/download-the-all-aware-app') {
    const queryParams = new URLSearchParams(window.location.search);
    if (!queryParams.has('ReturnUrl')) {
      const testimonials = document.getElementsByClassName('testimonial');
      for (const testimonial of testimonials) {
        testimonial.style.display = 'none';
      }
    }
  }
})();

/*****************************
 ****** Common functions *****
 *****************************/

window.getIsWebview = function () {
  const navigator = window.navigator;
  const standalone = navigator.standalone;
  const userAgent = navigator.userAgent.toLowerCase();
  const isIos = /ip(ad|hone|od)/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /android/.test(userAgent);
  const isSafari = /safari/.test(userAgent);
  const isWebview = (isAndroid && /; wv\)/.test(userAgent)) || (isIos && !standalone && !isSafari);
  return isWebview;
};

window.getCookie = function (name) {
  const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
};

window.setCookie = function (name, value, hours) {
  let expires = '';
  if (hours) {
    const d = new Date();
    d.setTime(d.getTime() + 60 * 60 * 1000 * hours);
    expires = ';expires=' + d.toGMTString();
  }
  document.cookie = name + '=' + value + ';path=/' + expires;
};

window.clearCookie = function (name, path) {
  var path = path || '/';
  document.cookie = name + '=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
};

window.readCookie = function (name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
